var render = function render() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c("div", [
    _c(
      "p",
      {
        staticClass: "mb-0",
      },
      [
        _vm.item_transactionable.match(/AffiliateTransaction/g) &&
        _vm.item_type == "credit"
          ? _c(
              "v-chip",
              {
                staticClass: "ma-2",
                attrs: {
                  color: "orange",
                  "text-color": "white",
                  small: "",
                },
              },
              [_vm._v("\n      ผู้เล่นรับค่าแนะนำ\n    ")]
            )
          : _vm.item_transactionable.match(/TicketNumber/g) &&
            _vm.item_type == "credit"
          ? _c(
              "v-chip",
              {
                staticClass: "ma-2",
                attrs: {
                  color: "red",
                  "text-color": "white",
                  small: "",
                },
              },
              [_vm._v("\n      ผู้เล่นถูกรางวัล\n    ")]
            )
          : _vm.item_transactionable.match(/TicketNumber/g) &&
            _vm.item_type == "debit"
          ? _c(
              "v-chip",
              {
                staticClass: "ma-2",
                attrs: {
                  color: "warning",
                  small: "",
                },
              },
              [_vm._v("\n      ยกเลิกรายการ\n    ")]
            )
          : _vm.item_transactionable.match(/Ticket$/g) &&
            _vm.item_type == "credit"
          ? _c(
              "v-chip",
              {
                staticClass: "ma-2",
                attrs: {
                  color: "brown",
                  "text-color": "white",
                  small: "",
                },
              },
              [_vm._v("\n      ผู้เล่นคืนโพย\n    ")]
            )
          : _vm.item_transactionable.match(/Ticket$/g) &&
            _vm.item_type == "debit"
          ? _c(
              "v-chip",
              {
                staticClass: "ma-2",
                attrs: {
                  color: "success",
                  small: "",
                },
              },
              [_vm._v("\n      ผู้เล่นพนัน\n    ")]
            )
          : _vm.item_transactionable.match(/CashTransaction/g) &&
            _vm.item_type == "credit"
          ? _c(
              "v-chip",
              {
                staticClass: "ma-2",
                attrs: {
                  color: "red",
                  "text-color": "white",
                  small: "",
                },
              },
              [_vm._v("\n      ผู้เล่นเติมเครดิต\n    ")]
            )
          : _vm.item_transactionable.match(/CashTransaction/g) &&
            _vm.item_type == "debit"
          ? _c(
              "v-chip",
              {
                staticClass: "ma-2",
                attrs: {
                  color: "green",
                  "text-color": "white",
                  small: "",
                },
              },
              [_vm._v("\n      ผู้เล่นถอนเครดิต\n    ")]
            )
          : _vm.item_transactionable.match(/CreditTransaction/g) &&
            (_vm.item_type == "accom-debit" || _vm.item_type == "accom-credit")
          ? _c(
              "v-chip",
              {
                staticClass: "ma-2",
                attrs: {
                  color: "light",
                  small: "",
                },
              },
              [_vm._v("\n      สรุปยอดเครดิต\n    ")]
            )
          : _vm.item_transactionable.match(/DirectDebitTransaction/g) &&
            _vm.item_type == "credit"
          ? _c(
              "v-chip",
              {
                staticClass: "ma-2",
                attrs: {
                  color: "teal",
                  "text-color": "white",
                  small: "",
                },
              },
              [_vm._v("\n      เติมตรง\n    ")]
            )
          : _vm.item_transactionable.match(/DirectDebitTransaction/g) &&
            _vm.item_type == "debit"
          ? _c(
              "v-chip",
              {
                staticClass: "ma-2",
                attrs: {
                  color: "brown",
                  "text-color": "white",
                  small: "",
                },
              },
              [_vm._v("\n      ยกเลิกฝากตรง\n    ")]
            )
          : _vm.item_transactionable.match(/VIPLevelBonus/g) &&
            _vm.item_type == "credit"
          ? _c(
              "v-chip",
              {
                staticClass: "ma-2",
                attrs: {
                  color: "pink lighten-1",
                  "text-color": "white",
                  small: "",
                },
              },
              [_vm._v("\n      ผู้เล่นรับโบนัส VIP\n    ")]
            )
          : _vm.item_transactionable.match(/GambleGame/g) &&
            _vm.item_type == "credit"
          ? _c(
              "v-chip",
              {
                staticClass: "ma-2",
                attrs: {
                  color: "pink lighten-1",
                  "text-color": "white",
                  small: "",
                },
              },
              [_vm._v("\n      รับโบนัสยิงเลข\n    ")]
            )
          : _vm.item_transactionable.match(/CreditBack/g) &&
            _vm.item_type == "credit"
          ? _c(
              "v-chip",
              {
                staticClass: "ma-2",
                attrs: {
                  color: "pink lighten-1",
                  "text-color": "white",
                  small: "",
                },
              },
              [_vm._v("\n      คืนยอดเสีย\n    ")]
            )
          : _vm._e(),
      ],
      1
    ),
    _vm._v(" "),
    _vm.item_remark
      ? _c(
          "p",
          {
            staticClass: "mb-0 d-inline-block",
            staticStyle: {
              "font-size": "0.65em",
              "max-width": "230px",
              "word-wrap": "break-word",
            },
            attrs: {
              title: _vm.item_remark,
            },
          },
          [_vm._v("\n    " + _vm._s(_vm.item_remark) + "\n  ")]
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }